import script from "./companies-grid.vue?vue&type=script&setup=true&lang=js"
export * from "./companies-grid.vue?vue&type=script&setup=true&lang=js"

import "./companies-grid.vue?vue&type=style&index=0&id=6c765f70&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c765f70"]])

export default __exports__